import { lazy } from 'react'

export const LicensePageAsync = lazy(() => import('./LicensePage'))
